import React, { createContext, useContext, useState } from 'react';

const PointerLockContext = createContext(null);

export const usePointerLockContext = () => {
    const context = useContext(PointerLockContext);
    if (!context) {
        throw new Error('usePointerLockContext must be used within a PointerLockProvider');
    }
    return context;
};

export const PointerLockProvider = ({ children }) => {
    const [isTransforming, setIsTransforming] = useState(false);

    return (
        <PointerLockContext.Provider value={{
            isTransforming,
            setIsTransforming
        }}>
            {children}
        </PointerLockContext.Provider>
    );
}; 